{"rating":"4.9","reviewCount":"141","fetchedAt":"2026-10-24T21:53:38.414Z","source":"place-details"}